/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PolicyDto } from '../../models/policy-dto';

export interface PolicyControllerFindById$Params {
  id: string;
}

export function policyControllerFindById(http: HttpClient, rootUrl: string, params: PolicyControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<PolicyDto>> {
  const rb = new RequestBuilder(rootUrl, policyControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PolicyDto>;
    })
  );
}

policyControllerFindById.PATH = '/api/policy/{id}';
